import React from 'react';

export const UserName: React.FunctionComponent<{
  user: { first_name: string; last_name: string; email: string };
}> = React.memo(({ user: { first_name, last_name, email } }) => (
  <>{`${first_name ?? ''} ${last_name ?? ''} (${email ?? ''})`.trim()}</>
));
